import { render, staticRenderFns } from "./online-pk-statistics.vue?vue&type=template&id=25f7bc0a&scoped=true&"
import script from "./online-pk-statistics.vue?vue&type=script&lang=js&"
export * from "./online-pk-statistics.vue?vue&type=script&lang=js&"
import style0 from "./online-pk-statistics.vue?vue&type=style&index=0&id=25f7bc0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f7bc0a",
  null
  
)

export default component.exports